import React, { useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useSearchParams } from "react-router-dom";
import CheckButton from "react-validation/build/button";
import { useForm} from "react-hook-form";
import Form from "react-validation/build/form";
import { ToastContainer, toast} from 'react-toastify';

import ActivateUserService from "../../../services/user/activateUserService";
import AuthService from "../../../services/auth.service";
function Forgotpassword() {

  const [searchParams, setSearchParams] = useSearchParams();

  const [password,setPassword] = useState("");
  const [password2,setPassword2] = useState("");

  let navigate = useNavigate();

  const handleLogin = () => {
    
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      if (password === password2){
        let uuid = searchParams.get("uidb64")
        let email = searchParams.get('email')
        ActivateUserService.ForgotPassword(
          email,
          password,
          ).then(
            (response) => {
              if (response.data.success===1){
                AuthService.logout()
                setTimeout(()=>{
                  navigate("/login")
                },2000)
                toast.success(`${response.data.response}`,{
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",})
              }
              else{
                toast.error(`${response.data.error}`,{
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",})
              }
            },
            )
          
          }
          else{
            toast.error(`Confirm Password doesn't match with password `,{
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",})
          }
    }
  };

  const { register, handleSubmit , formState:{errors} } = useForm();
  const form = useRef();
  const checkBtn = useRef();

  return (
    <section>
    <div className="page-header section-height-75">
    <ToastContainer/>
    <div className="container"  style={{paddingLeft: 'var(--bs-gutter-x, 1.6rem)'}}>
      <div className="row">
        <div className="col-xl-4 col-lg-5 col-md-6 d-flex flex-column mx-auto">
          <div className="card  mt-8">
            <div className="card-header pb-0 text-left bg-transparent ">
              <h4 className="text-info text-gradient">
                Change Password            </h4>
            </div>
            <div className="card-body">
              <Form
                role="form text-left"
                onSubmit={handleSubmit(handleLogin)}
                ref={form}
              >
                <label>Password</label>
                <div className="mb-3">
                  <input
                    className="form-control  validate black-text"
                    name="Password"
                    type="Password"
                    placeholder='Password'
                    onChange={(e)=>setPassword(e.target.value)}
                  />
                </div>
                <label>Confirm Password</label>
                <div className="mb-3">
                  <input
                  className="form-control"
                  name="password2"
                  type="password"
                  placeholder='Confirm Password'
                onChange={(e)=>setPassword2(e.target.value)}
                  />
                </div>
                <div className="text-center">
                        <button
                          type="submit"
                          name="submit"
                          className="btn bg-gradient-info w-100 mt-4 mb-0"
                        >
                        Submit
                        </button>
                      </div>
                <CheckButton style={{ display: "none" }} ref={checkBtn} />
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
  )
}

export default Forgotpassword
